import { useTranslation } from 'react-i18next'
import { SwimLogoAnimated } from './SwimLogoAnimated'
import { GRADIENTS } from '@/lib/gradients'

interface SplashScreenProps {
  fading?: boolean
}

export function SplashScreen({ fading = false }: SplashScreenProps) {
  const { t } = useTranslation('common')
  const prefersReduced = typeof window !== 'undefined'
    ? window.matchMedia('(prefers-reduced-motion: reduce)').matches
    : false

  const exitDuration = prefersReduced ? 0 : 400
  const exitDelay = prefersReduced ? 0 : 200

  return (
    <div
      className="fixed inset-0 z-[9999] flex items-center justify-center"
      style={{
        background: GRADIENTS.splash,
        opacity: fading ? 0 : 1,
        transition: fading ? `opacity ${exitDuration}ms ease-out ${exitDelay}ms` : undefined,
        pointerEvents: fading ? 'none' : undefined,
      }}
      aria-live="polite"
      aria-label={t('splash.loading')}
      role="status"
    >
      <div
        className={prefersReduced ? undefined : 'animate-scale-in'}
        style={prefersReduced ? undefined : { animationDuration: '0.3s' }}
      >
        <div className="flex flex-col items-center gap-6">
          <SwimLogoAnimated />

          {/* Sweep progress bar — hidden for reduced motion */}
          {!prefersReduced && (
            <div
              className="h-0.5 w-16 rounded-full bg-ocean-500/30 overflow-hidden animate-fade-in"
              style={{ animationDelay: '0.5s' }}
            >
              <div className="h-full w-full bg-ocean-500" style={{
                animation: 'loading-sweep 1.2s ease-in-out 0.5s 2 both',
              }} />
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
